<template>
    <BaseLink
        :class="[$style.link, { [$style.selected]: props.isSelected }]"
        :data-interface-target="props.dataInterfaceTarget"
        :to="props.to"
        :target="props.target"
        :externalTo="props.externalTo"
        :disabled="props.isSelected"
        @click="emit('click', $event)"
    >
        <Icon
            :name="props.icon"
            :alt="`switch_to_${props.icon}`"
            :class="$style.icon"
            :lazy="props.lazyIcon"
        />
        <Typography
            type="label"
            size="xs"
            accent
            :responsive="false"
        >
            {{ title }}
        </Typography>
    </BaseLink>
</template>

<script lang="ts" setup>
import { RouteLocationRaw } from 'vue-router'

import BaseLink from '@/components_new/BaseLink.vue'
import Icon, { IconNameType } from '@/components_new/Icon/Icon.vue'
import Typography from '@/components_new/Typography.vue'
import { LinkTarget } from '@/types'

interface SwitcherProps {
    title: string
    icon: IconNameType
    to?: RouteLocationRaw
    externalTo?: string
    isSelected?: boolean
    dataInterfaceTarget: string
    target?: LinkTarget
    lazyIcon?: boolean
}

const props = withDefaults(defineProps<SwitcherProps>(), {
    lazyIcon: true,
})

const emit = defineEmits<{ click: [event: Event] }>()
</script>

<style module>
.link {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    border-radius: 1000px;
    padding: 6px 12px 6px 6px;
    --main: transparent;
    --border-color: var(--white-12);
    background-color: var(--main);
    border: 1px solid var(--border-color);
}

.selected {
    cursor: default;
}

.link:hover {
    --border-color: transparent;
    color: var(--white);
    --main: var(--white-12);
}

.link:hover.selected {
    color: var(--black);
}

.link:active,
.link.selected {
    color: var(--black);
    --border-color: var(--white);
    --main: var(--white);
}

.link:focus-visible {
    --border-color: var(--carbon-500);
}

.icon {
    width: 24px;
    height: 24px;
}
</style>
